import React from 'react'
import create from 'zustand'
import createContext from 'zustand/context'
import shallow from 'zustand/shallow'

const { Provider, useStore } = createContext()

// 切换表单数据不更新,是不是可以提供一个innit方法
const createStore = (props) => {
  const {
    operatorConfig,
    fields,
    OperateComponent,
    FixedOperateComponent,
    inlineEdit,
    showFixedOperation,
  } = props
  return create((set) => {
    const setFields = (fieldsArr) => {
      set(() => ({ fields: fieldsArr }))
    }
    const setInlineEdit = (info) => {
      set(() => ({ inlineEdit: info }))
    }
    const setOperatorConfig = (config) => {
      set(() => ({ operatorConfig: config }))
    }
    const setOperateComponent = (component) => {
      set(() => ({ OperateComponent: component }))
    }

    const setFixedOperateComponent = (component) => {
      set(() => ({ FixedOperateComponent: component }))
    }

    // const init = (operatorConfig, fields, OperateComponent) => {
    //   // 需重置
    //   set(() => ({
    //     inited: true,
    //     fields,
    //     operatorConfig,
    //     OperateComponent,
    //   }))
    // }

    return {
      // inited: false,
      fields,
      operatorConfig,
      OperateComponent,
      FixedOperateComponent,
      inlineEdit,
      showFixedOperation,
      setFields,
      setInlineEdit,
      setOperatorConfig,
      setOperateComponent,
      setFixedOperateComponent,
      // init,
    }
  })
}

const ListStoreProvider = function ({ children, ...props }) {
  return (
    <Provider
      createStore={() => {
        return createStore(props)
      }}
      // createStore={createStore}
    >
      {children}
    </Provider>
  )
}

const useListStore = (selectors, equalityFn = shallow) =>
  useStore(selectors, equalityFn)

export { ListStoreProvider, useListStore }
